module.exports = __webpack_public_path__ + "img/6D.25ec6572.png";